export default {
  allMaintenanceStatus: [],
}
